/*
  Naoko — <naoko-barcode value="…"> — prawdziwy, skanowalny kod Code 128 (zestaw B)
  rysowany jako SVG. Plan: docs/lp-london-calling-plan.md (§4).

  - Treść: atrybut `value` (ASCII 32–126). Polskie znaki są transliterowane
    (ł→l, ą→a…), reszta spoza ASCII wypada.
  - Opcjonalny `value-wide`: dłuższy napis używany tylko wtedy, gdy mieści się
    w szerokości hosta przy module ≥ 1 px (szeroka karta desktop = gęstszy kod
    jak w Figmie); w węższym hoście wraca `value`.
  - Kod wypełnia CAŁĄ szerokość hosta (jak w Figmie), krawędzie wygładzane —
    o ile moduł ma ≥ 1,75 piksela urządzenia (telefony, Retina, Windows 125 %+).
    Poniżej tego progu moduł ułamkowy się nie dekoduje (zxing: zrzuty + symulacja
    aparatu), więc na ekranie 1× moduł = 1 px urządzenia, ostre krawędzie, a brakujące
    piksele (do 1 px na znak) rozkładane w przerwy między znakami — kod nadal równo
    z polem; przy większej nadwyżce bywa krótszy niż host. Moduł < 1 px urządzenia
    (bardzo wąsko) = i tak nieczytelny → pełna szerokość.
  - Kod wyrównany do lewej; wysokość = wysokość hosta (ustawiana w CSS).
  - Przerysowuje się przy zmianie `value` i szerokości hosta.
*/
(function () {
  if (window.customElements.get('naoko-barcode')) return;

  /* Szerokości pasków/przerw dla wartości 0–106 (103–105 = START A/B/C, 106 = STOP). */
  var PATTERNS = (
    '212222 222122 222221 121223 121322 131222 122213 122312 132212 221213 ' +
    '221312 231212 112232 122132 122231 113222 123122 123221 223211 221132 ' +
    '221231 213212 223112 312131 311222 321122 321221 312212 322112 322211 ' +
    '212123 212321 232121 111323 131123 131321 112313 132113 132311 211313 ' +
    '231113 231311 112133 112331 132131 113123 113321 133121 313121 211331 ' +
    '231131 213113 213311 213131 311123 311321 331121 312113 312311 332111 ' +
    '314111 221411 431111 111224 111422 121124 121421 141122 141221 112214 ' +
    '112412 122114 122411 142112 142211 241211 221114 413111 241112 134111 ' +
    '111242 121142 121241 114212 124112 124211 411212 421112 421211 212141 ' +
    '214121 412121 111143 111341 131141 114113 114311 411113 411311 113141 ' +
    '114131 311141 411131 211412 211214 211232 2331112'
  ).split(' ');
  var START_B = 104;
  var STOP = 106;

  var PL = { 'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
    'Ą': 'A', 'Ć': 'C', 'Ę': 'E', 'Ł': 'L', 'Ń': 'N', 'Ó': 'O', 'Ś': 'S', 'Ź': 'Z', 'Ż': 'Z' };

  function toAscii(str) {
    var s = String(str || '').replace(/[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/g, function (c) { return PL[c]; });
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return s.replace(/[^\x20-\x7e]/g, '');
  }

  /* Tablica szerokości (pasek, przerwa, pasek, …) w modułach. */
  function encode(text) {
    var codes = [START_B];
    var sum = START_B;
    for (var i = 0; i < text.length; i++) {
      var v = text.charCodeAt(i) - 32;
      codes.push(v);
      sum += v * (i + 1);
    }
    codes.push(sum % 103);
    codes.push(STOP);
    var widths = [];
    for (var j = 0; j < codes.length; j++) {
      var p = PATTERNS[codes[j]];
      for (var k = 0; k < p.length; k++) widths.push(+p[k]);
    }
    return widths;
  }

  var SVG_NS = 'http://www.w3.org/2000/svg';

  class NaokoBarcode extends HTMLElement {
    static get observedAttributes() { return ['value', 'value-wide']; }

    connectedCallback() {
      var self = this;
      /* setTimeout: connectedCallback odpala się, zanim przeglądarka policzy layout
         (i przed dziećmi przy parsowaniu) — rysujemy po pierwszym przebiegu. */
      setTimeout(function () { self.render(true); }, 0);
      if (!this._ro && window.ResizeObserver) {
        this._ro = new ResizeObserver(function () { self.render(false); });
        this._ro.observe(this);
      }
    }

    disconnectedCallback() {
      if (this._ro) { this._ro.disconnect(); this._ro = null; }
    }

    attributeChangedCallback() {
      if (this.isConnected) this.render(true);
    }

    render(force) {
      var cw = this.clientWidth;
      if (!cw) return;
      var text = toAscii(this.getAttribute('value'));
      var wide = toAscii(this.getAttribute('value-wide'));
      /* szerokość kodu w modułach: 11 na znak + START, suma kontrolna, STOP */
      if (wide && 11 * wide.length + 35 <= cw) text = wide;
      var key = text + '|' + cw + '|' + (window.devicePixelRatio || 1);
      if (!force && key === this._key) return;
      this._key = key;
      if (!text) { this.replaceChildren(); return; }

      var widths = encode(text);
      var modules = 0;
      for (var i = 0; i < widths.length; i++) modules += widths[i];
      this.setAttribute('data-encoded', text);

      var dpr = window.devicePixelRatio || 1;
      var boxDev = Math.floor(cw * dpr);
      var mDev = boxDev / modules;
      var crisp = mDev >= 1 && mDev < 1.75;
      var units = widths;
      var total = modules;
      var widthCss = cw;
      if (crisp) {
        /* Ekran ~1×: moduł = 1 px urządzenia (ostre krawędzie). Brakujące do pełnej
           szerokości piksele idą po 1 px w końcowe przerwy znaków (6. element każdego
           symbolu) — do 1 px na znak kod nadal się dekoduje (zxing), więc kod kończy się
           równo z polem. Przy większej nadwyżce zostaje krótszy niż pole. */
        units = widths.slice();
        var nsym = (widths.length - 7) / 6;
        var extra = boxDev - modules;
        if (extra > 0 && extra <= nsym) {
          for (var j = 0; j < extra; j++) units[6 * Math.floor(((j + 0.5) * nsym) / extra) + 5] += 1;
          total = boxDev;
        }
        widthCss = total / dpr;
      }

      var svg = document.createElementNS(SVG_NS, 'svg');
      svg.setAttribute('viewBox', '0 0 ' + total + ' 1');
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.setAttribute('shape-rendering', crisp ? 'crispEdges' : 'geometricPrecision');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.style.display = 'block';
      svg.style.width = widthCss + 'px';
      svg.style.height = '100%';

      var x = 0;
      for (var b = 0; b < units.length; b++) {
        if (b % 2 === 0) {
          var r = document.createElementNS(SVG_NS, 'rect');
          r.setAttribute('x', x);
          r.setAttribute('y', 0);
          r.setAttribute('width', units[b]);
          r.setAttribute('height', 1);
          svg.appendChild(r);
        }
        x += units[b];
      }
      this.replaceChildren(svg);
    }
  }

  NaokoBarcode.toAscii = toAscii;
  window.customElements.define('naoko-barcode', NaokoBarcode);
})();
